/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles, themeV2 } from 'utils/themeV2';



/* ++++++++++ --------------- EXPORT : AUTH SIGNUP COMPLETE : STYLES --------------- ++++++++++ */
export default theme => ({
    signupcompletepage:{
        '& .copy':{
            height: '100%',
            maxWidth: `${pxToEm(460)} !important`,
            '& .bodycopy':{
                color: themeV2.color.primary.main,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly'
            }
        },
        '& .group':{
            height: pxToEm(215)
        },
        '& button':{
            width: '100%',
            ...buttonStyles
        },
        '& .congrats':{
            fontWeight: 500
        }
    }
});
